import React, { Component } from 'react';

class AboutUsSection extends Component {
    render() {
        return (
            <section className="aboutUs" id="aboutUs">
                <div className="container">
                <div className="aboutUsContent">
                <h2>About Us</h2>
                <div className="decoration"></div>
                <p>Nori grape silver beet broccoli kombu beet greens fava bean potato quandong celery. Bunya nuts black-eyed pea prairie turnip leek lentil turnip greens parsnip.</p>
                <div className="signatureSpace">
                    <div className="aboutUsSignature"></div>
                </div>
            </div>
                    <div className="aboutUsImage"></div>
                </div>
            </section>
        )
    }
}

export default AboutUsSection;